import { ReactNode } from "react";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { JobPhase } from "generated/graphql";
import Title from "./Title";
import AdditionalCostsTable from "./jobDetails/AdditionalCostsTable";
import EquipmentTable from "./jobDetails/EquipmentTable";
import LaborTable from "./jobDetails/LaborTable";
import MaterialsTable from "./jobDetails/MaterialsTable";
import StatementOfWorkTable from "./jobDetails/StatementOfWorkTable";
import usePlantRows from "./jobDetails/usePlantRows";

export default function JobDetails({
  jobPhase,
  sideContent,
}: {
  jobPhase: JobPhase;
  sideContent?: ReactNode;
}) {
  const plantRows = usePlantRows(jobPhase);

  return (
    <MDBox mb={2} className="no-break">
      <Card>
        <Title text="Job Phase Details" />
        <MDBox
          p={3}
          sx={{
            "@media print": {
              padding: 1,
            },
          }}
        >
          <StatementOfWorkTable jobPhase={jobPhase} />
          <MaterialsTable plantRows={plantRows} jobPhase={jobPhase} />
          <Grid container spacing={2} alignItems="stretch">
            <Grid item xs={12} md={6}>
              <LaborTable jobPhase={jobPhase} />
              <EquipmentTable jobPhase={jobPhase} />
              <AdditionalCostsTable jobPhase={jobPhase} />
            </Grid>

            {sideContent ? (
              <Grid item xs={12} md={6}>
                {sideContent}
              </Grid>
            ) : null}
          </Grid>
        </MDBox>
      </Card>
    </MDBox>
  );
}
